import {
  transformExportParamsToCrudApi,
  transformParamsToCrudApi,
} from '@app/core/crud/listing-adapter';
import { convertGetManyResponse } from '@app/core/crud/response-converter';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { ListView } from '@app/core/list-view/ListView';
import { ListViewExportParams, ListViewQueryParams } from '@app/core/list-view/types';
import { auditReports, auditReportsApiClient } from '@mi-front/api-clients';
import { Paginated } from '@mi-front/core';
import { AodRunsList } from './AodRunsList';
import { AOD_RUNS_FILTERS_CONFIG } from './filter-config';

/**
 * AOD Runs List V2 page: ListView with filter bar (including date range) and table.
 */
export function AodRunsListPageV2() {
  const timezone = useTimezone();

  const queryFn = async (
    params: ListViewQueryParams,
  ): Promise<Paginated<auditReports.AodRunInGetManyDto>> => {
    return auditReports
      .getManyBaseAodRunsControllerAodRun({
        ...transformParamsToCrudApi(params, {
          filterDefinitions: AOD_RUNS_FILTERS_CONFIG,
          context: { timezone },
        }),
        join: ['rule'],
      })
      .then(convertGetManyResponse);
  };

  const exportFn = async (params: ListViewExportParams) => {
    return auditReportsApiClient({
      method: 'GET',
      url: `/aod-runs/export`,
      params: {
        ...transformExportParamsToCrudApi(params, {
          filterDefinitions: AOD_RUNS_FILTERS_CONFIG,
          context: { timezone },
        }),
        join: ['rule'],
      },
      responseType: 'arraybuffer',
    });
  };

  return (
    <ListView
      listId="aod-runs-list-v2"
      queryFn={queryFn}
      exportFn={exportFn}
      filters={AOD_RUNS_FILTERS_CONFIG}
      ListComponent={AodRunsList}
    />
  );
}
